import './WhatsappButton.css';
import Icon from '../images/assets/icon.png';
const WhatsappButton = () => {

    return (
        <>
            <a href="https://wa.link/sqpagj" target="_blank" rel="noopener noreferrer" className="whatsapp-button">
                <img src={Icon} alt="WhatsApp Icon" className="whatsapp-icon" />
            </a>
        </>
    );
}
export default WhatsappButton;